export const styles = {
  chip: (backgroundColor, color) => {
    return {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '0px 8px',
      borderRadius: '20px',
      backgroundColor,
      color: `${color}!important`,
      border: (theme) => !color && `1px solid ${theme.palette.grays.gray400}`,
    };
  },
  text: (color) => {
    return {
      maxWidth: '100px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: '12px',
      fontWeight: 400,
      color: `${color}!important`,
    };
  },
};
